import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04ab44ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-share" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-download-file" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-download-file" }, null, -1))
const _hoisted_4 = ["href", "download"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-download-file" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-logo-circle" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-move-folder" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-copy-content" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-trash" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-info" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!
  const _component_app_skeleton_case_view = _resolveComponent("app-skeleton-case-view")!
  const _component_app_solo_case_selector = _resolveComponent("app-solo-case-selector")!
  const _component_mixed_media_info_pop_up = _resolveComponent("mixed-media-info-pop-up")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_app_bottom_pop_up, {
      onHide: _ctx.hidePopUp,
      "hide-bottom-decoration": "",
      "hide-top-decoration": "",
      class: "bottom-popup"
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.isPhoto ? _ctx.$localize('media.settings.popup.title.type.photo') : _ctx.$localize('media.settings.popup.title.type.file')), 1)
      ]),
      body: _withCtx(() => [
        (!_ctx.isNetwork && _ctx.isMy)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('onShare');})
            }, {
              icon: _withCtx(() => [
                _hoisted_1
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('photo.view.share')) + " ", 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.mainStore.isNative)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadMedia && _ctx.downloadMedia(...args))),
              href: "javascript:void(0);",
              class: "link"
            }, [
              _createVNode(_component_bottom_pop_up_item, null, {
                icon: _withCtx(() => [
                  _hoisted_2
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$localize('media.settings.popup.download')) + " ", 1)
                ]),
                _: 1
              })
            ]))
          : (_ctx.mainStore.isFlutter)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.downloadMediaFlutter && _ctx.downloadMediaFlutter(...args))),
                href: "javascript:void(0);",
                class: "link"
              }, [
                _createVNode(_component_bottom_pop_up_item, null, {
                  icon: _withCtx(() => [
                    _hoisted_3
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('media.settings.popup.download')) + " ", 1)
                  ]),
                  _: 1
                })
              ]))
            : (_ctx.mainStore.isMobile)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 3,
                  href: _ctx.downloadUrl,
                  download: _ctx.file.name,
                  class: "link"
                }, [
                  _createVNode(_component_bottom_pop_up_item, null, {
                    icon: _withCtx(() => [
                      _hoisted_5
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('media.settings.popup.download')) + " ", 1)
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_4))
              : _createCommentVNode("", true),
        (!_ctx.isNetwork && _ctx.isMy)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 4,
              onClick: _ctx.editFile
            }, {
              icon: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.rename.option')) + " ", 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.isNetwork && _ctx.isMy)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 5,
              onClick: _ctx.openMovePopUp
            }, {
              icon: _withCtx(() => [
                _hoisted_7
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('media.settings.popup.move')) + " ", 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.allowSave)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 6,
              onClick: _ctx.saveMediaAsCopy
            }, {
              icon: _withCtx(() => [
                _hoisted_8
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('media.settings.popup.copy')) + " ", 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isNetwork && !_ctx.isMy)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 7,
              onClick: _ctx.removeSharing
            }, {
              icon: _withCtx(() => [
                _hoisted_9
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('case.settings.popup.remove.sharing')) + " ", 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.isNetwork && _ctx.isMy)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 8,
              onClick: _ctx.deleteMedia
            }, {
              icon: _withCtx(() => [
                _hoisted_10
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('media.settings.popup.delete')) + " ", 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.isNetwork && _ctx.isMy)
          ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
              key: 9,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showInfo = true))
            }, {
              icon: _withCtx(() => [
                _hoisted_11
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('photo.view.info')) + " ", 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onHide"]),
    (_ctx.caseViewSkeleton)
      ? (_openBlock(), _createBlock(_component_app_skeleton_case_view, {
          key: 0,
          title: _ctx.skeletonCase.title,
          photoSkeletons: _ctx.skeletonCase.photosAmount,
          fileSkeletons: _ctx.skeletonCase.filesAmount
        }, null, 8, ["title", "photoSkeletons", "fileSkeletons"]))
      : _createCommentVNode("", true),
    (_ctx.caseSelector)
      ? (_openBlock(), _createBlock(_component_app_solo_case_selector, {
          key: 1,
          title: "Add to Case",
          onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.caseSelector = false)),
          onDone: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addMediaToCase($event)))
        }))
      : _createCommentVNode("", true),
    (_ctx.showInfo)
      ? (_openBlock(), _createBlock(_component_mixed_media_info_pop_up, {
          key: 2,
          file: _ctx.file,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showInfo = false))
        }, null, 8, ["file"]))
      : _createCommentVNode("", true)
  ]))
}